import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AboutsService {

  constructor(private http: HttpClient) {}
  addAbout(body) {
    return this.http.post<ApiResponseModel>('api/about', body);
  }
  getAboutById(id) {
    return this.http.get<ApiResponseModel>('/api/about/' + id);
  }
  editAbout(body, id) {
    return this.http.patch<ApiResponseModel>('/api/about/' + id, body);
  }

}
